import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FOLLIA_GRADIENT_SVG_DATA, FOLLIA_SVG_DATA } from './icons-svg-compiled';

/**
 * Service per registrare le icone personalizzate della ZCS
 */
@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {}

  /**
   * Registra le icone SVG personalizzate nel registro di Angular Material.
   * * @description
   * Utilizziamo `addSvgIconLiteral` invece di `addSvgIcon` con URL esterno per i seguenti motivi:
   * * 1. **Zero Latenza (Performance):** Evita una richiesta HTTP GET aggiuntiva al caricamento
   * del componente. L'icona è renderizzata istantaneamente insieme al bundle JS,
   * eliminando il delay (es. 800ms) e il flickering visivo.
   * * 2. **Affidabilità:** L'asset non dipende dalla disponibilità della cartella `/assets`
   * o da configurazioni di path relativi che potrebbero variare tra i diversi ambienti
   * di deploy.
   * * 3. **Bundling:** Integrando l'SVG come costante stringa, l'icona viene trattata come
   * codice sorgente, permettendo al browser di averla già pronta nella cache della memoria RAM.
   * * @example
   *  Nel template HTML:
   *  <mat-icon svgIcon="follia_svg"></mat-icon>
   */
  registerIcons() {
    this.matIconRegistry.addSvgIconLiteral(
      'follia_svg',
      this.domSanitizer.bypassSecurityTrustHtml(FOLLIA_SVG_DATA),
    );

    this.matIconRegistry.addSvgIconLiteral(
      'follia_gradient_svg',
      this.domSanitizer.bypassSecurityTrustHtml(FOLLIA_GRADIENT_SVG_DATA),
    );

    // Aggiungere qui tutte le altre icone in futuro
  }
}
